import $ from 'jquery';

(function () {
  const $body = $('body');

  $('[data-navigation-panel-toggle]').on('click', function (event) {
    event.preventDefault();
    if ($body.hasClass('body--navigation-panel-visible')) {
      $body.removeClass('body--navigation-panel-visible');
    } else {
      $body.addClass('body--navigation-panel-visible');
    }
  });
})();
